import { render, staticRenderFns } from "./detail_stat.vue?vue&type=template&id=afee69fc&scoped=true&"
import script from "./detail_stat.vue?vue&type=script&lang=js&"
export * from "./detail_stat.vue?vue&type=script&lang=js&"
import style0 from "./detail_stat.vue?vue&type=style&index=0&id=afee69fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afee69fc",
  null
  
)

export default component.exports